// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// /home/pablo/vortex/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!/home/pablo/vortex/node_modules/vue-style-loader!/home/pablo/vortex/node_modules/css-loader?{"sourceMap":true}!/home/pablo/vortex/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2ae8b464","scoped":false,"hasInlineConfig":false}!/home/pablo/vortex/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/ranking.vue
// module id = EBZ9
// module chunks = 0